"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _wsActions = require("../actions/ws-actions");

var _util = require("./util");

var _appSocketMiddleware = require("../middleware/app-socket-middleware");

var _helocActions = require("../actions/heloc-actions");

var _helocCoDeedActions = require("../actions/heloc-co-deed-actions");

var _merlocActions = require("../actions/merloc-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  helocsByUuid: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   uuid: '',
    //   loanNumber: '',
    //   amount: 0,
    //   reason: '',
    //   rate: 0,
    //   primeRate: 0,
    //   term: 0,
    //   rateType: '',
    //   payType: '',
    //   identityUuid: '00000000-0000-0000-0000-000000000000',
    //   income: 0,
    //   incomePrimary: 0,
    //   incomeCoDeeders: 0,
    //   incomeOther: 0,
    //   incomeSources: [],
    //   documents: [],
    //   consents: [],
    //   crossSellApps: [],
    //   disburseAccount: {
    //     uuid,
    //     accountType,
    //     routingNumber,
    //     accountNumber,
    //     ownerName,
    //     achAccountId
    //   },
    //   autopayAccount: {
    //     uuid,
    //     accountType,
    //     routingNumber,
    //     accountNumber,
    //     ownerName,
    //     achAccountId
    //   },
    //   plaidAssetsLinkedDate: '',
    //   property: {
    //     city: '',
    //     state: '',
    //     street1: '',
    //     street2: '',
    //     type: 'HOME',
    //     uuid: '',
    //     zip: '',
    //     ownership: ''
    //   },
    //   selectedPropertyUuid: '',
    //   propertyHasExistingMortgage: false,
    //   propertyListedForSale: false,
    //   identityReviewed: false,
    //   coDeedIdentityUuids: [],
    //   coDeedStatus: '', // IN_PROGRESS|COMPLETE
    //   insurance: {
    //     floodInsured: false,
    //     homeownersInsured: false,
    //     complete: false
    //   },
    //   hasFrozenPin: false,
    //   active: true,
    //   activeForAppStart: true,
    //   assetDepletion: {
    //     retirement: 0,
    //     savings: 0,
    //     investment: 0,
    //     complete: false
    //   },
    //   incomeVerificationRequestUuid: '',
    //   organization: '', // FIGURE|CALIBER|PETERSENDEAN
    //   originationFeePercentage: 0
    //   hasHmda: false,
    //   lienAttestation: false,  // MERLOC
    //   initialMonthlyPayment: 0 // MERLOC
    //   projectAmount: 0 // MERLOC
    //   status: {
    //     avmMatch: false,
    //     creditFrozen: false,
    //     creditFrozenWithPin: false,
    //     creditLocked: false,
    //     softCreditFico: 0,
    //     softCreditNoMatchWithSsn: false,
    //     softCreditNoMatch: false,
    //     docVerifyStatus: '',
    //     uwDecision: '',
    //     uwSubDecision: '',
    //     disclosurelistUuid: '',
    //     disclosurelistAppReady: false,
    //     disclosurelistClosingReady: false,
    //     disclosurelistClosingComplete: false,
    //     disclosurelistNotaryReady: false,
    //     disclosurelistNotaryComplete: false,
    //     giactAccountStatus: '',
    //     idBypass: false,
    //     manualDeedSigningComplete: false,
    //     checklistStatus: '',
    //     hasAal: false,
    //     manualDeed: false,
    //     participantAcceptComplete: false,
    //     primaryParticipantAcceptComplete: false,
    //     contextReady: false,
    //     contextLeadReady: false,
    //     firstLien: false,
    //     cancellationStatus: '',
    //     dtiDecline: false,
    //     creditScoreDecline: false,
    //     incomeVerificationResultUuid: '',
    //     canIncomeVerify: false
    //     plCrossSell: false,
    //     propertyNoMatch: false,
    //     propertyComplete: false,
    //     datatreeNoMatch: false,
    //     datatreeComplete: false,
    //     liensComplete: false,
    //     liensReady: false,
    //     showDelinquencyReview: false,
    //   },
    //   auditFields: {
    //     createdDate: ''
    //   },
    //   selectedDiscounts: [],
    //   subOrganization: '',
    //   ownershipChanged: false,
    // }
  },
  activeUuid: '',
  socketConnected: false,
  loading: false,
  error: ''
};
exports.initialState = initialState;

function merge(state, action) {
  var helocUuid = action.payload.uuid;
  var heloc = state.helocsByUuid[helocUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    helocsByUuid: _objectSpread(_objectSpread({}, state.helocsByUuid), {}, (0, _defineProperty2.default)({}, helocUuid, _objectSpread(_objectSpread({}, heloc), {}, {
      uuid: helocUuid,
      loanNumber: action.payload.loanNumber,
      amount: action.payload.amount,
      reason: action.payload.reason,
      reasonDescription: action.payload.reasonDescription,
      rate: action.payload.rate,
      primeRate: action.payload.primeRate,
      term: action.payload.term,
      rateType: action.payload.rateType,
      payType: action.payload.payType,
      identityUuid: action.payload.identityUuid,
      income: action.payload.income,
      incomePrimary: action.payload.incomePrimary,
      incomeCoDeeders: action.payload.incomeCoDeeders,
      incomeOther: action.payload.incomeOther,
      incomeSources: (0, _util.mergeList)(heloc.incomeSources, action.payload.incomeSources),
      consents: (0, _util.mergeList)(heloc.consents, action.payload.consents),
      crossSellApps: action.payload.crossSellApps,
      documents: (0, _util.mergeList)(heloc.documents, action.payload.documents),
      disburseAccount: _objectSpread(_objectSpread({}, heloc.disburseAccount), {}, {
        uuid: action.payload.disburseAccount.uuid,
        accountType: action.payload.disburseAccount.accountType,
        accountTypeDescription: action.payload.disburseAccount.accountTypeDescription,
        routingNumber: action.payload.disburseAccount.routingNumber,
        accountNumber: action.payload.disburseAccount.accountNumber,
        ownerName: action.payload.disburseAccount.ownerName,
        achAccountId: action.payload.disburseAccount.achAccountId
      }),
      autopayAccount: _objectSpread(_objectSpread({}, heloc.autopayAccount), {}, {
        uuid: action.payload.autopayAccount.uuid,
        accountType: action.payload.autopayAccount.accountType,
        accountTypeDescription: action.payload.autopayAccount.accountTypeDescription,
        routingNumber: action.payload.autopayAccount.routingNumber,
        accountNumber: action.payload.autopayAccount.accountNumber,
        ownerName: action.payload.autopayAccount.ownerName,
        achAccountId: action.payload.autopayAccount.achAccountId
      }),
      plaidAssetsLinkedDate: action.payload.plaidAssetsLinkedDate,
      property: _objectSpread(_objectSpread({}, heloc.property), {}, {
        uuid: action.payload.property.uuid,
        type: action.payload.property.type,
        typeDescription: action.payload.property.typeDescription,
        street1: action.payload.property.street1,
        street2: action.payload.property.street2,
        city: action.payload.property.city,
        state: action.payload.property.state,
        zip: action.payload.property.zip,
        ownership: action.payload.property.ownership,
        ownershipDescription: action.payload.property.ownershipDescription,
        ownerLegalName: action.payload.property.ownerLegalName
      }),
      selectedPropertyUuid: action.payload.selectedPropertyUuid,
      propertyHasExistingMortgage: action.payload.propertyHasExistingMortgage,
      propertyListedForSale: action.payload.propertyListedForSale,
      identityReviewed: action.payload.identityReviewed,
      coDeedIdentityUuids: action.payload.coDeedIdentityUuids.slice(),
      coDeedStatus: action.payload.coDeedStatus,
      insurance: {
        floodInsured: action.payload.insurance.floodInsured,
        homeownersInsured: action.payload.insurance.homeownersInsured,
        complete: action.payload.insurance.complete
      },
      hasFrozenPin: action.payload.hasFrozenPin,
      active: action.payload.active,
      activeForAppStart: action.payload.activeForAppStart,
      assetDepletion: {
        retirement: action.payload.assetDepletion.retirement,
        savings: action.payload.assetDepletion.savings,
        investment: action.payload.assetDepletion.investment,
        complete: action.payload.assetDepletion.complete
      },
      incomeVerificationRequestUuid: action.payload.incomeVerificationRequestUuid,
      organization: action.payload.organization,
      originationFeePercentage: action.payload.originationFeePercentage,
      hasHmda: action.payload.hasHmda,
      lienAttestation: action.payload.lienAttestation,
      initialMonthlyPayment: action.payload.initialMonthlyPayment,
      projectAmount: action.payload.projectAmount,
      hasTShirtSize: action.payload.hasTShirtSize,
      status: _objectSpread(_objectSpread({}, heloc.status), {}, {
        avmMatch: action.payload.status.avmMatch,
        creditFrozen: action.payload.status.creditFrozen,
        creditFrozenWithPin: action.payload.status.creditFrozenWithPin,
        creditLocked: action.payload.status.creditLocked,
        softCreditFico: action.payload.status.softCreditFico,
        softCreditNoMatch: action.payload.status.softCreditNoMatch,
        softCreditNoMatchWithSsn: action.payload.status.softCreditNoMatchWithSsn,
        docVerifyStatus: action.payload.status.docVerifyStatus,
        uwDecision: action.payload.status.uwDecision,
        uwSubDecision: action.payload.status.uwSubDecision,
        disclosurelistUuid: action.payload.status.disclosurelistUuid,
        disclosurelistAppReady: action.payload.status.disclosurelistAppReady,
        disclosurelistSummaryReady: action.payload.status.disclosurelistSummaryReady,
        disclosurelistSummaryComplete: action.payload.status.disclosurelistSummaryComplete,
        disclosurelistClosingReady: action.payload.status.disclosurelistClosingReady,
        disclosurelistClosingComplete: action.payload.status.disclosurelistClosingComplete,
        disclosurelistNotaryReady: action.payload.status.disclosurelistNotaryReady,
        disclosurelistNotaryComplete: action.payload.status.disclosurelistNotaryComplete,
        bypassVoeReview: action.payload.status.bypassVoeReview,
        employmentVerificationNeeded: action.payload.status.employmentVerificationNeeded,
        giactAccountStatus: action.payload.status.giactAccountStatus,
        idBypass: action.payload.status.idBypass,
        manualDeedSigningComplete: action.payload.status.manualDeedSigningComplete,
        checklistStatus: action.payload.status.checklistStatus,
        manualNotary: action.payload.status.manualNotary,
        pldTaskComplete: action.payload.status.pldTaskComplete,
        hasAal: action.payload.status.hasAal,
        manualDeed: action.payload.status.manualDeed,
        participantAcceptComplete: action.payload.status.participantAcceptComplete,
        primaryParticipantAcceptComplete: action.payload.status.primaryParticipantAcceptComplete,
        contextReady: action.payload.status.contextReady,
        contextLeadReady: action.payload.status.contextLeadReady,
        firstLien: action.payload.status.firstLien,
        cancellationStatus: action.payload.status.cancellationStatus,
        dtiDecline: action.payload.status.dtiDecline,
        creditScoreDecline: action.payload.status.creditScoreDecline,
        incomeVerificationResultUuid: action.payload.status.incomeVerificationResultUuid,
        canIncomeVerify: !action.payload.incomeVerificationRequestUuid || action.payload.status.incomeVerificationResultUuid === action.payload.incomeVerificationRequestUuid,
        manualPaystubUpload: action.payload.status.manualPaystubUpload,
        manualPaystubTasksComplete: action.payload.status.manualPaystubTasksComplete,
        plCrossSell: action.payload.status.plCrossSell,
        propertyNoMatch: action.payload.status.propertyNoMatch,
        propertyComplete: action.payload.status.propertyComplete,
        datatreeNoMatch: action.payload.status.datatreeNoMatch,
        datatreeComplete: action.payload.status.datatreeComplete,
        liensComplete: action.payload.status.liensComplete,
        liensReady: action.payload.status.liensReady,
        showDelinquencyReview: action.payload.status.showDelinquencyReview
      }),
      maritalStatus: action.payload.maritalStatus,
      requestedManualNotaryTime: action.payload.requestedManualNotaryTime,
      requestedManualNotaryAddress: action.payload.requestedManualNotaryAddress,
      auditFields: _objectSpread(_objectSpread({}, heloc.auditFields), {}, {
        createdDate: action.payload.auditFields.createdDate
      }),
      manualPaystubs: action.payload.manualPaystubs,
      selectedDiscounts: action.payload.selectedDiscounts,
      subOrganization: action.payload.subOrganization,
      ownershipChanged: action.payload.ownershipChanged
    }))),
    loading: false,
    error: ''
  });
}

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _helocActions.ACTIVATE_HELOC, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return _objectSpread(_objectSpread({}, state), {}, {
    activeUuid: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocActions.SAVE_HELOC, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_HELOC_V2, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.UPDATE_HELOC, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_ASSET_DEPLETION, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_FROZEN_PIN, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_PRODUCT, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_PAY_TYPE, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_PROPERTY, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_PROPERTY_V2, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_CONSENT, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_CONSENT_LIST, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_REASON, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_INCOME_VERIFICATION_REQUEST, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_AUTOPAY_ACH, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_DISBURSE_ACH, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_DISBURSE_ACH_PLAID, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_REVIEW, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_INSURANCE, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.SAVE_CO_DEED, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.SAVE_STATUS, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.REMOVE_CO_DEED, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_INCOME_SOURCE, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_HMDA, "_").concat(_httpActions.REQUEST), "".concat(_merlocActions.SAVE_LIEN_ATTESTATION, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SET_PLAID_ASSETS_LINKED, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SAVE_MANUAL_PAYSTUB_DATA, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.BYPASS_ID_VERIFICATION, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.GIACT_ACCOUNT_VERIFICATION, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.SEND_EMPLOYER_VERIFICATION, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.CONFIRM_OFFER, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocActions.GET_HELOC, "_").concat(_httpActions.REQUEST), "".concat(_helocActions.GET_USER_HELOCS, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: '',
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocActions.SAVE_HELOC, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_HELOC_V2, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.UPDATE_HELOC, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_ASSET_DEPLETION, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_FROZEN_PIN, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_PRODUCT, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_PAY_TYPE, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_PROPERTY, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_PROPERTY_V2, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_CONSENT, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_CONSENT_LIST, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_REASON, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_INCOME_VERIFICATION_REQUEST, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_AUTOPAY_ACH, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_DISBURSE_ACH, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_DISBURSE_ACH_PLAID, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_REVIEW, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_INSURANCE, "_").concat(_httpActions.FAILURE), "".concat(_helocCoDeedActions.SAVE_CO_DEED, "_").concat(_httpActions.FAILURE), "".concat(_helocCoDeedActions.SAVE_STATUS, "_").concat(_httpActions.FAILURE), "".concat(_helocCoDeedActions.REMOVE_CO_DEED, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_INCOME_SOURCE, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_HMDA, "_").concat(_httpActions.FAILURE), "".concat(_merlocActions.SAVE_LIEN_ATTESTATION, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SET_PLAID_ASSETS_LINKED, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SAVE_MANUAL_PAYSTUB_DATA, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.BYPASS_ID_VERIFICATION, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.GIACT_ACCOUNT_VERIFICATION, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.SEND_EMPLOYER_VERIFICATION, "_").concat(_httpActions.FAILURE), "".concat(_helocActions.CONFIRM_OFFER, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocActions.GET_HELOC, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_HELOC, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_HELOC_V2, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.UPDATE_HELOC, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_ASSET_DEPLETION, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_FROZEN_PIN, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_PRODUCT, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_PAY_TYPE, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_PROPERTY, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_PROPERTY_V2, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_CONSENT, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_CONSENT_LIST, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_REASON, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_INCOME_VERIFICATION_REQUEST, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_AUTOPAY_ACH, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_DISBURSE_ACH, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_DISBURSE_ACH_PLAID, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_REVIEW, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_INSURANCE, "_").concat(_httpActions.SUCCESS), "".concat(_helocCoDeedActions.SAVE_CO_DEED, "_").concat(_httpActions.SUCCESS), "".concat(_helocCoDeedActions.SAVE_STATUS, "_").concat(_httpActions.SUCCESS), "".concat(_helocCoDeedActions.REMOVE_CO_DEED, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_INCOME_SOURCE, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_HMDA, "_").concat(_httpActions.SUCCESS), "".concat(_merlocActions.SAVE_LIEN_ATTESTATION, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SET_PLAID_ASSETS_LINKED, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SAVE_MANUAL_PAYSTUB_DATA, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.BYPASS_ID_VERIFICATION, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.GIACT_ACCOUNT_VERIFICATION, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.SEND_EMPLOYER_VERIFICATION, "_").concat(_httpActions.SUCCESS), "".concat(_helocActions.CONFIRM_OFFER, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  return merge(state, action);
}), (0, _defineProperty2.default)(_handleActions, "".concat(_helocActions.GET_USER_HELOCS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  if (!action.payload.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: '',
      loading: false
    });
  }

  var helocsByUuid = action.payload.map(function (h) {
    var heloc = state.helocsByUuid[h.uuid] || {};
    return _objectSpread(_objectSpread({}, heloc), {}, {
      uuid: h.uuid,
      loanNumber: h.loanNumber,
      amount: h.amount,
      reason: h.reason,
      reasonDescription: h.reasonDescription,
      rate: h.rate,
      primeRate: h.primeRate,
      term: h.term,
      rateType: h.rateType,
      payType: h.payType,
      identityUuid: h.identityUuid,
      income: h.income,
      incomePrimary: h.incomePrimary,
      incomeCoDeeders: h.incomeCoDeeders,
      incomeOther: h.incomeOther,
      incomeSources: (0, _util.mergeList)(heloc.incomeSources, h.incomeSources),
      consents: (0, _util.mergeList)(heloc.consents, h.consents),
      crossSellApps: h.crossSellApps,
      documents: (0, _util.mergeList)(heloc.documents, h.documents),
      disburseAccount: _objectSpread(_objectSpread({}, heloc.disburseAccount), {}, {
        uuid: h.disburseAccount.uuid,
        accountType: h.disburseAccount.accountType,
        accountTypeDescription: h.disburseAccount.accountTypeDescription,
        routingNumber: h.disburseAccount.routingNumber,
        accountNumber: h.disburseAccount.accountNumber,
        ownerName: h.disburseAccount.ownerName,
        achAccountId: h.disburseAccount.achAccountId
      }),
      autopayAccount: _objectSpread(_objectSpread({}, heloc.autopayAccount), {}, {
        uuid: h.autopayAccount.uuid,
        accountType: h.autopayAccount.accountType,
        accountTypeDescription: h.autopayAccount.accountTypeDescription,
        routingNumber: h.autopayAccount.routingNumber,
        accountNumber: h.autopayAccount.accountNumber,
        ownerName: h.autopayAccount.ownerName,
        achAccountId: h.autopayAccount.achAccountId
      }),
      plaidAssetsLinkedDate: h.plaidAssetsLinkedDate,
      property: _objectSpread(_objectSpread({}, heloc.property), {}, {
        uuid: h.property.uuid,
        type: h.property.type,
        typeDescription: h.property.typeDescription,
        street1: h.property.street1,
        street2: h.property.street2,
        city: h.property.city,
        state: h.property.state,
        zip: h.property.zip,
        ownership: h.property.ownership,
        ownershipDescription: h.property.ownershipDescription,
        ownerLegalName: h.property.ownerLegalName
      }),
      selectedPropertyUuid: h.selectedPropertyUuid,
      propertyHasExistingMortgage: h.propertyHasExistingMortgage,
      propertyListedForSale: h.propertyListedForSale,
      identityReviewed: h.identityReviewed,
      coDeedIdentityUuids: h.coDeedIdentityUuids.slice(),
      coDeedStatus: h.coDeedStatus,
      insurance: {
        floodInsured: h.insurance.floodInsured,
        homeownersInsured: h.insurance.homeownersInsured,
        complete: h.insurance.complete
      },
      hasFrozenPin: h.hasFrozenPin,
      active: h.active,
      activeForAppStart: h.activeForAppStart,
      assetDepletion: {
        retirement: h.assetDepletion.retirement,
        savings: h.assetDepletion.savings,
        investment: h.assetDepletion.investment,
        complete: h.assetDepletion.complete
      },
      incomeVerificationRequestUuid: h.incomeVerificationRequestUuid,
      organization: h.organization,
      originationFeePercentage: h.originationFeePercentage,
      hasHmda: h.hasHmda,
      lienAttestation: h.lienAttestation,
      initialMonthlyPayment: h.initialMonthlyPayment,
      projectAmount: action.payload.projectAmount,
      hasTShirtSize: h.hasTShirtSize,
      status: _objectSpread(_objectSpread({}, heloc.status), {}, {
        avmMatch: h.status.avmMatch,
        creditFrozen: h.status.creditFrozen,
        creditLocked: h.status.creditLocked,
        creditFrozenWithPin: h.status.creditFrozenWithPin,
        softCreditFico: h.status.softCreditFico,
        softCreditNoMatch: h.status.softCreditNoMatch,
        softCreditNoMatchWithSsn: h.status.softCreditNoMatchWithSsn,
        docVerifyStatus: h.status.docVerifyStatus,
        uwDecision: h.status.uwDecision,
        uwSubDecision: h.status.uwSubDecision,
        disclosurelistUuid: h.status.disclosurelistUuid,
        disclosurelistAppReady: h.status.disclosurelistAppReady,
        disclosurelistSummaryReady: h.status.disclosurelistSummaryReady,
        disclosurelistSummaryComplete: h.status.disclosurelistSummaryComplete,
        disclosurelistClosingReady: h.status.disclosurelistClosingReady,
        disclosurelistClosingComplete: h.status.disclosurelistClosingComplete,
        disclosurelistNotaryReady: h.status.disclosurelistNotaryReady,
        disclosurelistNotaryComplete: h.status.disclosurelistNotaryComplete,
        bypassVoeReview: h.status.bypassVoeReview,
        employmentVerificationNeeded: h.status.employmentVerificationNeeded,
        giactAccountStatus: h.status.giactAccountStatus,
        manualDeedSigningComplete: h.status.manualDeedSigningComplete,
        checklistStatus: h.status.checklistStatus,
        manualNotary: h.status.manualNotary,
        pldTaskComplete: h.status.pldTaskComplete,
        hasAal: h.status.hasAal,
        manualDeed: h.status.manualDeed,
        participantAcceptComplete: h.status.participantAcceptComplete,
        primaryParticipantAcceptComplete: h.status.primaryParticipantAcceptComplete,
        contextReady: h.status.contextReady,
        contextLeadReady: h.status.contextLeadReady,
        firstLien: h.status.firstLien,
        cancellationStatus: h.status.cancellationStatus,
        dtiDecline: h.status.dtiDecline,
        creditScoreDecline: h.status.creditScoreDecline,
        incomeVerificationResultUuid: h.status.incomeVerificationResultUuid,
        canIncomeVerify: !h.incomeVerificationRequestUuid || h.status.incomeVerificationResultUuid === h.incomeVerificationRequestUuid,
        manualPaystubUpload: h.status.manualPaystubUpload,
        manualPaystubTasksComplete: h.status.manualPaystubTasksComplete,
        plCrossSell: h.status.plCrossSell,
        propertyNoMatch: h.status.propertyNoMatch,
        propertyComplete: h.status.propertyComplete,
        datatreeNoMatcho: h.status.datatreeNoMatch,
        datatreeComplete: h.status.datatreeComplete,
        liensComplete: h.status.liensComplete,
        liensReady: h.status.liensReady,
        showDelinquencyReview: h.status.showDelinquencyReview
      }),
      maritalStatus: h.maritalStatus,
      requestedManualNotaryTime: h.requestedManualNotaryTime,
      requestedManualNotaryAddress: h.requestedManualNotaryAddress,
      auditFields: _objectSpread(_objectSpread({}, heloc.auditFields), {}, {
        createdDate: h.auditFields.createdDate
      }),
      selectedDiscounts: h.selectedDiscounts,
      subOrganization: h.subOrganization,
      manualPaystubs: h.manualPaystubs
    });
  }).reduce(function (result, h) {
    var keyValue = {};
    keyValue[h.uuid] = h;
    return Object.assign({}, result, keyValue);
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    helocsByUuid: _objectSpread(_objectSpread({}, state.helocsByUuid), helocsByUuid),
    loading: false,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_appSocketMiddleware.APP, "_").concat(_wsActions.SOCKET_OPEN), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    socketConnected: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_appSocketMiddleware.MERCHANT, "_").concat(_wsActions.SOCKET_MESSAGE), function _(state, action) {
  var payload = JSON.parse(action.payload);
  var key = payload.applicationUuid;
  var value = state.helocsByUuid[key] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    helocsByUuid: _objectSpread(_objectSpread({}, state.helocsByUuid), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, value), {}, {
      status: _objectSpread(_objectSpread({}, value.status), payload)
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_appSocketMiddleware.APP, "_").concat(_wsActions.SOCKET_MESSAGE), function _(state, action) {
  var payload = JSON.parse(action.payload);
  var helocUuid = payload.applicationUuid; // confirm that app type is heloc or ignore

  if (state.activeUuid !== helocUuid && !state.helocsByUuid[helocUuid]) return state;
  var heloc = state.helocsByUuid[helocUuid];
  if (!heloc) return state; // if the heloc is missing, ignore

  var status = payload.status;
  var isInitial = payload.topic === 'INITIAL';
  var isAvm = isInitial || payload.topic === 'AVM';
  var isSoftCredit = isInitial || payload.topic === 'SOFT_CREDIT';
  var isHardCredit = isInitial || payload.topic === 'HARD_CREDIT';
  var isCredit = isInitial || isSoftCredit || isHardCredit;
  var isProperty = isInitial || payload.topic === 'PROPERTY';
  var isDatatree = isInitial || payload.topic === 'DATATREE';
  var isUnderwriting = isInitial || payload.topic === 'UW_DECISION';
  var isDocVerify = isInitial || payload.topic === 'DOC_VERIFY';
  var isChecklist = isInitial || payload.topic === 'CHECKLIST';
  var isAal = isInitial || payload.topic === 'AAL';
  var isDisclosure = isInitial || payload.topic === 'DISCLOSURELIST';
  var isParticipantAccept = isInitial || payload.topic === 'PARTICIPANT_ACCEPT';
  var isContextReady = isInitial || payload.topic === 'CONTEXT';
  return _objectSpread(_objectSpread({}, state), {}, {
    helocsByUuid: _objectSpread(_objectSpread({}, state.helocsByUuid), {}, (0, _defineProperty2.default)({}, helocUuid, _objectSpread(_objectSpread({}, heloc), {}, {
      status: _objectSpread(_objectSpread({}, heloc.status), {}, {
        avmMatch: isAvm ? status.avmMatch : heloc.status.avmMatch,
        creditFrozen: isCredit ? status.creditFrozen : heloc.status.creditFrozen,
        creditLocked: isCredit ? status.creditLocked : heloc.status.creditLocked,
        creditFrozenWithPin: isCredit ? status.creditFrozenWithPin : heloc.status.creditFrozenWithPin,
        softCreditFico: isSoftCredit ? status.softCreditFico : heloc.status.softCreditFico,
        softCreditNoMatch: isSoftCredit ? status.softCreditNoMatch : heloc.status.softCreditNoMatch,
        softCreditNoMatchWithSsn: isSoftCredit ? status.softCreditNoMatchWithSsn : heloc.status.softCreditNoMatchWithSsn,
        propertyNoMatch: isProperty ? status.propertyNoMatch : heloc.status.propertyNoMatch,
        propertyComplete: isProperty ? status.propertyComplete : heloc.status.propertyComplete,
        datatreeNoMatch: isDatatree ? status.datatreeNoMatch : heloc.status.datatreeNoMatch,
        datatreeComplete: isDatatree ? status.datatreeComplete : heloc.status.datatreeComplete,
        docVerifyStatus: isDocVerify ? status.docVerifyStatus : heloc.status.docVerifyStatus,
        uwDecision: isUnderwriting ? status.uwDecision : heloc.status.uwDecision,
        uwSubDecision: isUnderwriting ? status.uwSubDecision : heloc.status.uwSubDecision,
        disclosurelistUuid: isDisclosure ? status.disclosurelistUuid : heloc.status.disclosurelistUuid,
        disclosurelistAppReady: isDisclosure ? status.disclosurelistAppReady : heloc.status.disclosurelistAppReady,
        disclosurelistSummaryReady: isDisclosure ? status.disclosurelistSummaryReady : heloc.status.disclosurelistSummaryReady,
        disclosurelistSummaryComplete: isDisclosure ? status.disclosurelistSummaryComplete : heloc.status.disclosurelistSummaryComplete,
        disclosurelistClosingReady: isDisclosure ? status.disclosurelistClosingReady : heloc.status.disclosurelistClosingReady,
        disclosurelistClosingComplete: isDisclosure ? status.disclosurelistClosingComplete : heloc.status.disclosurelistClosingComplete,
        disclosurelistNotaryReady: isDisclosure ? status.disclosurelistNotaryReady : heloc.status.disclosurelistNotaryReady,
        disclosurelistNotaryComplete: isDisclosure ? status.disclosurelistNotaryComplete : heloc.status.disclosurelistNotaryComplete,
        giactAccountStatus: isInitial ? status.giactAccountStatus : heloc.status.giactAccountStatus,
        manualDeedSigningComplete: isChecklist ? status.manualDeedSigningComplete : heloc.status.manualDeedSigningComplete,
        checklistStatus: isChecklist ? status.checklistStatus : heloc.status.checklistStatus,
        hasAal: isAal ? status.hasAal : heloc.status.hasAal,
        manualDeed: isChecklist ? status.manualDeed : heloc.status.manualDeed,
        participantAcceptComplete: isParticipantAccept ? status.participantAcceptComplete : heloc.status.participantAcceptComplete,
        primaryParticipantAcceptComplete: isParticipantAccept ? status.primaryParticipantAcceptComplete : heloc.status.primaryParticipantAcceptComplete,
        contextReady: isContextReady ? status.contextReady : heloc.status.contextReady,
        contextLeadReady: isContextReady ? status.contextLeadReady : heloc.status.contextLeadReady,
        firstLien: isUnderwriting ? status.firstLien : heloc.status.firstLien,
        cancellationStatus: isChecklist ? status.cancellationStatus : heloc.status.cancellationStatus,
        dtiDecline: isUnderwriting ? status.dtiDecline : heloc.status.dtiDecline,
        creditScoreDecline: isUnderwriting ? status.creditScoreDecline : heloc.status.creditScoreDecline,
        incomeVerificationResultUuid: isUnderwriting ? status.incomeVerificationResultUuid : heloc.status.incomeVerificationResultUuid,
        canIncomeVerify: isUnderwriting ? !heloc.incomeVerificationRequestUuid || heloc.incomeVerificationRequestUuid === status.incomeVerificationResultUuid : heloc.status.canIncomeVerify,
        plCrossSell: isUnderwriting ? status.plCrossSell : heloc.status.plCrossSell,
        liensComplete: isInitial ? status.liensComplete : heloc.status.liensComplete,
        liensReady: isInitial ? status.liensReady : heloc.status.liensReady,
        bypassVoeReview: isInitial ? status.bypassVoeReview : heloc.status.bypassVoeReview,
        showDelinquencyReview: isInitial ? status.showDelinquencyReview : heloc.status.showDelinquencyReview
      })
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_appSocketMiddleware.APP, "_").concat(_wsActions.SOCKET_CLOSE), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    socketConnected: false
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;